import { SESSION_TYPE_BUMBLEBEE_STATUS } from "../types/bumblebee.type";
import type { BumblebeeSessionListItem } from "../types/bumblebee.type";
import type { SessionMetadata } from "../types/session.type";

export function isBumblebeeSession(
	session: Pick<SessionMetadata, "session_type"> | null | undefined,
): boolean {
	return session?.session_type === SESSION_TYPE_BUMBLEBEE_STATUS;
}

export function mapBumblebeeToSessionMetadata(
	item: BumblebeeSessionListItem,
): SessionMetadata {
	return {
		session_id: item.session_id,
		user_id: "",
		title: item.display_title,
		created_at: item.created_at,
		updated_at: item.updated_at,
		is_deleted: false,
		message_count: item.message_count,
		session_type: SESSION_TYPE_BUMBLEBEE_STATUS,
		campaign_id: item.campaign_id,
		is_read_only: item.is_read_only,
		can_delete: item.can_delete,
		has_unread: item.has_unread,
		unread_count: item.unread_count ?? 0,
	};
}
